import type {FC, ComponentPropsWithoutRef} from "react"
import {createElement, useMemo} from "react"

import cn from "classnames"

import isUrlExternal from "lib/utils/isUrlExternal"

import InternalAnchor from "./InternalAnchor"

export interface AnchorProps extends ComponentPropsWithoutRef<"a"> {
  /**
   * Если передан true - ссылка будет некликабильна
   */
  disable?: boolean

  /**
   * Если передан true - ссылка будет использовать нативный тег `<a>` вместо `next/link`
   */
  external?: boolean

  href: string
}

export const Anchor: FC<AnchorProps> = ({
  disable = false,
  external,
  children,

  ...props
}) => {
  const isExternal = useMemo<boolean>(
    () => (external == null ? isUrlExternal(props.href) : external),

    [props.href, external]
  )

  if (disable) {
    // * В сети пишут, что такой способ может привести к потенциальным проблем с a11y
    // * Если столкнёмся с чем-то таким - нужно будет усоершенствовать его
    return createElement("a", {
      ...props, className: cn("cursor-default", props.className), href: null
    }, children)
  }

  return createElement(isExternal ? "a" : InternalAnchor, props, children)
}
